// Modules
import { useTranslation } from 'react-i18next';

// Redux
import { useAppSelector } from '@global/store/hooks';
import { subscriptionSelector } from '@global/store/slices/subscription/selectors';

// Utils
import { buildTitleWithName } from '@global/utils/lang';
import { useAuth } from '@global/hooks/useAuth';
import { LOCALE_CODES } from '@global/types/types';

export const NotExist = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language as LOCALE_CODES;
  const { subscriptionsByUid } = useAppSelector(subscriptionSelector);

  const name =
    subscriptionsByUid[Object.keys(subscriptionsByUid)[0]]?.billingInfo?.name;

  const { user } = useAuth();

  return (
    <div className="no-sub">
      <div className="no-sub__info-wrapper">
        <span className="no-sub__title">
          {buildTitleWithName({
            name,
            locale,
            title: t('subDetails.noSub.title'),
          })}
        </span>
        {
          <span className="no-sub__message">
            {t('subDetails.noSub.message1', { userEmail: user?.email })}
          </span>
        }
      </div>
    </div>
  );
};
